// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import i18n from '@/i18n'
import ripple from 'vuetify/lib/directives/ripple'
// import { VData, VDataFooter } from 'vuetify/lib/components'

// VDataFooter.options.props.itemsPerPageOptions.default = () => [1, 2, 11, 100, -1]
// VData.options.props.itemsPerPage.default = () => 11

Vue.use(Vuetify, { directives: { ripple } })

const theme = {
  primary: '#0a9de8',
  secondary: '#9C27b0',
  accent: '#0a9de8',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
  edit: '#4CAF50',
  delete: '#F44336',
  save: '#4CAF50',
  export: '#00CAE3',
  cancel: '#FAFAFA',
  stat: '#a6e300',
  search: '#a6e300',
  action: '#00CAE3',
  empty: '#ECEFF1',
  run: '#0a9de8',
  rollback: '#F44336',
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: {
      login: 'mdi-login',
      expand: 'mdi-menu-down',
      document: 'mdi-file-document',
      documents: 'mdi-file-document-multiple',
      document_timeline: 'mdi-book-check',
      show: 'mdi-eye',
      dashboard: 'mdi-view-dashboard',
      user: 'mdi-account',
      users: 'mdi-account-group',
      reservations: 'mdi-calendar-multiselect',
      organizations: 'mdi-domain',
      transactions: 'mdi-cash-multiple',
      planes: 'mdi-airplane',
      airports: 'mdi-airport',
      logbook: 'mdi-text-box-multiple',
      flights: 'mdi-airplane-takeoff',
      administrations: 'mdi-cog',
      roles: 'mdi-shield-account',
      edit: 'mdi-pencil',
      notifications: 'mdi-bell',
      languages: 'mdi-earth',
      xlsx: 'mdi-microsoft-excel',
      pdf: 'mdi-file-pdf-box',
      search: 'mdi-magnify',
      upload: 'mdi-cloud-upload',
      info: 'mdi-information',
      email: 'mdi-email',
      phone: 'mdi-phone',
      facebook: 'mdi-facebook',
      google: 'mdi-google',
      delete: 'mdi-delete',
      vuetify: 'mdi-vuetify',
      operating_days: 'mdi-calendar-account',
      calendar: 'mdi-calendar',
      subscribe: 'mdi-thumb-up',
      unsubscribe: 'mdi-thumb-down',
      supervisor: 'mdi-security',
      modules: 'mdi-view-module',
      memberships: 'mdi-badge-account',
      permissions: 'mdi-shield-key',
      balances: 'mdi-account-cash',
      daily_flight: 'mdi-timer',
      takeoff: 'mdi-airplane-takeoff',
      landing: 'mdi-airplane-landing',
      check: 'mdi-check',
      close: 'mdi-close',
      duplicate: 'mdi-content-duplicate',
      swap: 'mdi-swap-horizontal',
      sunrise: 'mdi-weather-sunset-up',
      sunset: 'mdi-weather-sunset-down',
      chart: 'mdi-chart-areaspline',
      handshake: 'mdi-handshake',
      database_sync: 'mdi-database-sync',
      logout: 'mdi-logout',
      work_management: 'mdi-wheel-barrow',
      undertake: 'mdi-hand-back-left',
      lock_open: 'mdi-lock-open',
      lock: 'mdi-lock',
      actions: 'mdi-cog',
      pilot_info: 'mdi-shield-airplane',
      address_book: 'mdi-book-account',
      list: 'mdi-view-list',
      back: 'mdi-arrow-left-circle',
      user_training: 'mdi-notebook',
      success: 'mdi-check',
      unsuccess: 'mdi-close',
      add: 'mdi-plus',
      fingerprint: 'mdi-fingerprint',
      ogn: 'mdi-map-marker-radius',
      debug: 'mdi-shield-bug',
      maintenance: 'mdi-tools',
      maintenance_operations: 'mdi-wrench-clock',
      components: 'mdi-puzzle-edit',
      events: 'mdi-calendar-clock',
      refresh: 'mdi-refresh',
      reports: 'mdi-chart-box',
      export: 'mdi-export',
      planning: 'mdi-notebook-check',
      task_check: 'mdi-list-status',
      share: 'mdi-link-variant-plus',
      map: 'mdi-map-search',
      help: 'mdi-help',
      airport_operations: 'mdi-airport',
      type_lists: 'mdi-format-list-bulleted-type',
      payment: 'mdi-account-credit-card',
      settings: 'mdi-cogs',
      private_profile: 'mdi-card-account-details-star',
      package_down: 'mdi-package-down',
      upload_photo: 'mdi-image-search',
      scheduled_transactions: 'mdi-cash-clock',
      run: 'mdi-play',
      rollback: 'mdi-undo-variant',
      messages: 'mdi-message-text',
      trainings: 'mdi-book-cog',
      plane_fault_reports: 'mdi-airplane-alert',
      plane_fault_fix: 'mdi-wrench',
      subscriptions: 'mdi-playlist-check',
      analytics: 'mdi-poll',
      download: 'mdi-download',
      fuel: 'mdi-fuel',
    },
  },
  lang: { t: (key, ...params) => i18n.t(key, params) },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
